import { Component, Inject, OnInit } from '@angular/core';
import { BaseModalComponent } from 'app/shared/base-modal/base-modal.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { GecoPosMenu, Group } from 'app/models/menu.model';
import { Store } from '@ngrx/store';
import { selectMenu, selectOriginalDictionaryGroups } from 'app/reducers/menu.selectors';
import { menuHelper } from 'app/helpers/menuHelper';

@UntilDestroy()
@Component({
  selector: 'app-select-menu-groups-modal',
  templateUrl: './select-menu-groups-modal.component.html',
  styleUrls: ['./select-menu-groups-modal.component.scss']
})
export class SelectMenuGroupsModalComponent extends BaseModalComponent implements OnInit {

  sortedOriginalGroups: Group[] = [];
  checked: Map<string, boolean> = new Map<string, boolean>();
  hasChanged: boolean = false;

  isLoading = false;
  menu$: Observable<GecoPosMenu>;
  originalGroupMap$: Observable<Map<string, Group>>;

  constructor(
    public dialogRef: MatDialogRef<SelectMenuGroupsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectMenuGroupsModalComponentDataType,
    private translate: TranslateService,
    private store: Store,
  ) {
    super(dialogRef);
  }

  get title(): string {
    return this.translate.instant('MENU.SELECT_GROUPS_FOR_MENU', {name: this.data.menuName});
  }

  ngOnInit(): void {
    this.menu$ = this.store.select(selectMenu);
    this.originalGroupMap$ = this.store.select(selectOriginalDictionaryGroups);

    this.originalGroupMap$
      .pipe(
        untilDestroyed(this),
        tap(() => {
          this.sortedOriginalGroups = [];
        })
      )
      .subscribe((groupsMap) => {
        this.sortedOriginalGroups = menuHelper.sortGroupsByOriginalOrder(groupsMap.values());

        for (let group of this.sortedOriginalGroups) {
          const checked = this.data.groupIds.some(id => id === group.externalId);
          this.checked.set(group.externalId, checked);
        }
      });
  }

  save(): void {
    const newGroupsIds = [];
    for (const keyValue of this.checked.entries()) {
      if (keyValue[1]) {
        newGroupsIds.push(keyValue[0]);
      }
    }

    this.dialogRef.close({data: newGroupsIds});
  }

  handleCheckGroup(group: Group, checked): void {
    this.hasChanged = true;
    this.checked.set(group.externalId, checked);
  }

  isChecked(group: Group): boolean {
    return this.checked.get(group.externalId);
  }
}

export interface SelectMenuGroupsModalComponentDataType {
  menuName: string;
  groupIds: string[];
}
